import { NOTIFICATION_MANAGEMENT_BASE_URL } from 'configs';
import request from 'utils/axios';
import {
  INotificationListRequest,
  INotificationListResponse,
  IUnreadCountResponse,
  IMarkAsReadRequest,
  IMarkAsUnreadRequest,
  IDeleteNotificationRequest,
} from './types';

const SEGMENT = `${NOTIFICATION_MANAGEMENT_BASE_URL}/api/v1/notification`;

export const getUnreadNotificationsByUserId = (
  userId: number,
  params: INotificationListRequest,
): Promise<INotificationListResponse> => {
  const url = `${SEGMENT}/users/${userId}`;
  return request({
    url,
    method: 'GET',
    params,
  });
};

export const getAllNotificationsByUserId = (
  userId: number,
  params: INotificationListRequest,
): Promise<INotificationListResponse> => {
  const url = `${SEGMENT}/users/${userId}/all`;
  return request({
    url,
    method: 'GET',
    params,
  });
};

export const getUnreadNotificationCount = (userId: number): Promise<IUnreadCountResponse> => {
  const url = `${SEGMENT}/users/${userId}/unread-count`;
  return request({
    url,
    method: 'GET',
  });
};

export const markNotificationsAsRead = (notificationIds: IMarkAsReadRequest): Promise<void> => {
  const url = `${SEGMENT}/mark-as-read`;
  return request({
    url,
    method: 'POST',
    data: notificationIds,
  });
};

export const markNotificationsAsUnread = (data: IMarkAsUnreadRequest): Promise<void> => {
  const url = `${SEGMENT}/mark-as-unread`;
  return request({
    url,
    method: 'POST',
    data,
  });
};

export const deleteNotifications = (data: IDeleteNotificationRequest): Promise<void> => {
  const url = SEGMENT;
  return request({
    url,
    method: 'DELETE',
    data,
  });
};
